export const GameModuleIcon = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.125 11.25V12.375C7.125 13.0712 6.84844 13.7389 6.35616 14.2312C5.86387 14.7234 5.19619 15 4.5 15C3.80381 15 3.13613 14.7234 2.64384 14.2312C2.15156 13.7389 1.875 13.0712 1.875 12.375V7.125M10.875 11.25V12.375C10.875 13.0712 11.1516 13.7389 11.6438 14.2312C12.1361 14.7234 12.8038 15 13.5 15C14.1962 15 14.8639 14.7234 15.3562 14.2312C15.8484 13.7389 16.125 13.0712 16.125 12.375V7.125"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 3H6C3.72183 3 1.875 4.84683 1.875 7.125C1.875 9.40317 3.72183 11.25 6 11.25H12C14.2782 11.25 16.125 9.40317 16.125 7.125C16.125 4.84683 14.2782 3 12 3Z"
        stroke="white"
      />
      <path
        d="M7.875 7.125H4.875M6.375 5.625V8.625"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.5 6.375C13.5 5.96079 13.1642 5.625 12.75 5.625C12.3358 5.625 12 5.96079 12 6.375C12 6.78921 12.3358 7.125 12.75 7.125C13.1642 7.125 13.5 6.78921 13.5 6.375Z"
        fill="white"
      />
      <path
        d="M12 8.25C12 7.83579 11.6642 7.5 11.25 7.5C10.8358 7.5 10.5 7.83579 10.5 8.25C10.5 8.66421 10.8358 9 11.25 9C11.6642 9 12 8.66421 12 8.25Z"
        fill="white"
      />
    </svg>
  );
};

export default GameModuleIcon;
